import { Button } from "@blueprintjs/core";
import * as React from "react";

import { ERoutes } from "../../AppRouter";
import { useNavigationContext } from "../../contexts";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";

interface IBackButtonProps {
  backRoute: ERoutes | string;
}

export const BackButton: React.FunctionComponent<IBackButtonProps> = ({
  backRoute,
}) => {
  const { t } = useTl();
  const { goBack } = useNavigationContext();

  return (
    <Button
      title={`${t(ETLCodes.GoBack)}`}
      icon="arrow-left"
      intent="primary"
      minimal={true}
      onClick={() => goBack(backRoute)}
    ></Button>
  );
};
